// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stepper-main {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.stepper-main .v-stepper__header {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}", ""]);
// Exports
module.exports = exports;
